export interface SearchIndexEntry<T> {
  item: T;
  tokens: string[];
}

const tokenize = (value: string): string[] => {
  return value
    .toLowerCase()
    .normalize('NFKD')
    .replace(/\p{Diacritic}/gu, '')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim()
    .split(/\s+/)
    .filter((token) => token.length > 0);
};

const normalizeInput = (input: string | null | undefined): string => {
  if (!input) {
    return '';
  }
  return input;
};

export const buildSearchIndex = <T>(
  items: readonly T[],
  extractor: (item: T) => Array<string | null | undefined>
): SearchIndexEntry<T>[] => {
  return items.map((item) => {
    const fields = extractor(item);
    const tokenSet = new Set<string>();
    fields.forEach((field) => {
      tokenize(normalizeInput(field)).forEach((token) => tokenSet.add(token));
    });
    return {
      item,
      tokens: Array.from(tokenSet)
    };
  });
};

export const searchIndex = <T>(
  entries: readonly SearchIndexEntry<T>[],
  query: string
): T[] => {
  const tokens = tokenize(query);
  if (tokens.length === 0) {
    return entries.map((entry) => entry.item);
  }

  return entries
    .filter((entry) =>
      tokens.every((token) => entry.tokens.some((candidate) => candidate.includes(token)))
    )
    .map((entry) => entry.item);
};

